import React from 'react';
import classNames from 'classnames';
import styles from './SidebarPayconFtueTooltip.css';

function Tooltip(props) {
  const {
    step,
    tooltipProps,
    primaryProps,
    closeProps,
    index,
    size,
    isLastStep,
    onJumpToStep,
  } = props;
  const { title, content, locale } = step;

  const stepDots = [];

  for (let i = 0; i < size; ++i) {
    const isActive = i === index;
    const dotStyles = classNames(styles.stepDot, {
      [styles.stepDotActive]: isActive,
    });
    const dotProps = {
      key: i,
      className: dotStyles,
    };
    if (!isActive) {
      dotProps.onClick = () => onJumpToStep(i);
    }

    const dot = <div {...dotProps} />;
    stepDots.push(dot);
  }

  return (
    <div {...tooltipProps} className={styles.container}>
      <a {...closeProps} type="button" className={styles.closeButton}>
        &times;
      </a>
      <div className={styles.title}>{title}</div>
      <div>{content}</div>

      <div className={styles.footer}>
        <div className={styles.stepDotContainer}>{stepDots}</div>
        <button {...primaryProps} type="button" className="btn btn-primary">
          {isLastStep ? locale.last : locale.next}
        </button>
      </div>
    </div>
  );
}

export default Tooltip;
